import { Instagram, Mail, ArrowUpRight, MessageCircle } from "lucide-react";

export default function ContactLinks({ whatsapp, instagram, email, testPrefix = "" }) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center">
      {whatsapp && (
        <a
          data-testid={`contact${testPrefix}-whatsapp-link`}
          href={`https://wa.me/${whatsapp.replace(/[^0-9]/g, "")}`}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-3 rounded-full bg-cream px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-umber transition-colors duration-300 hover:bg-gild hover:text-umber"
        >
          <MessageCircle className="h-4 w-4" />
          WhatsApp
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      )}
      {instagram && (
        <a
          data-testid={`contact${testPrefix}-instagram-link`}
          href={`https://instagram.com/${instagram.replace(/^@/, "")}`}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-3 rounded-full bg-cream px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-umber transition-colors duration-300 hover:bg-gild hover:text-umber"
        >
          <Instagram className="h-4 w-4" />
          @{instagram.replace(/^@/, "")}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      )}
      {email && (
        <a
          data-testid={`contact${testPrefix}-email-link`}
          href={`mailto:${email}?subject=Artwork%20Inquiry`}
          className="group inline-flex items-center gap-3 rounded-full border border-cream/25 px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-cream transition-colors duration-300 hover:border-gild hover:text-gild"
        >
          <Mail className="h-4 w-4" />
          {email}
        </a>
      )}
    </div>
  );
}
